module.exports = __webpack_public_path__ + "static/img/icon slt img.45032bda.svg";